export function getPasswordValidationState(password = '', passwordConfirmation = '') {
  return {
    length: password.length >= 8 && password.length <= 15,
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
    match: passwordConfirmation.length > 0 && password === passwordConfirmation
  }
}

export function getPasswordRequirements(password = '', passwordConfirmation = '') {
  const checks = getPasswordValidationState(password, passwordConfirmation)

  return [
    { key: 'length', label: 'Entre 8 y 15 caracteres', met: checks.length },
    { key: 'lower', label: 'Al menos 1 letra minúscula (a-z)', met: checks.lower },
    { key: 'number', label: 'Al menos 1 número (0-9)', met: checks.number },
    { key: 'special', label: 'Al menos 1 carácter especial', met: checks.special },
    { key: 'match', label: 'Las contraseñas coinciden', met: checks.match }
  ]
}

export function isPasswordValid(password = '', passwordConfirmation = '') {
  const checks = getPasswordValidationState(password, passwordConfirmation)
  return checks.length && checks.lower && checks.number && checks.special && checks.match
}
